import { formatScore } from '@/utils/formatScore';

/** Umbrales horarios del saludo del encabezado. */
const NOON_HOUR = 12;
const EVENING_HOUR = 18;

export interface TrendIndicator {
  /** Clase Font Awesome de la flecha de tendencia. */
  icon: string;
  /** Modificador de color de la píldora de tendencia. */
  className: string;
  /** Clave i18n del texto de tendencia. */
  textKey: string;
}

/**
 * Traduce la diferencia de promedio entre el mes actual y el de referencia a la
 * flecha, el color y el texto de la píldora de tendencia.
 */
export function trendIndicator(diff: number): TrendIndicator {
  if (diff > 0) {
    return { icon: 'fa-arrow-trend-up', className: 'green', textKey: 'safe.trend.up' };
  }
  if (diff < 0) {
    return { icon: 'fa-arrow-trend-down', className: 'orange', textKey: 'safe.trend.down' };
  }
  return { icon: 'fa-minus', className: 'muted', textKey: 'safe.trend.stable' };
}

/**
 * Formatea una variación con signo explícito; cadena vacía si no hay comparación.
 * Pasa por `formatScore`, el único formateador de decimales de la pantalla, y solo
 * antepone el signo.
 */
export function formatDelta(delta: number | null): string {
  if (delta === null) return '';
  const magnitude = formatScore(Math.abs(delta));
  return delta >= 0 ? `+${magnitude}` : `-${magnitude}`;
}

/** Clave i18n del saludo según la hora local. */
export function greetingKey(hour: number): string {
  if (hour < NOON_HOUR) return 'survey.greetingMorning';
  if (hour < EVENING_HOUR) return 'survey.greetingAfternoon';
  return 'survey.greetingEvening';
}
